import { CancelButton, GroupButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import FormTitle from '@core/components/FormTitle';
import { DateLabel, TextLabel } from '@core/components/Inputs';
import { useApiUtils } from '@core/util/apiUtils';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid, makeStyles } from '@material-ui/core';
import { CompraContext } from 'app/main/compra/CompraContext';
import { fechamentoPeriodoApi } from 'app/services/api/fechamentoPeriodoApi';
import * as Actions from 'app/store/actions';
import moment from 'moment';
import NP from 'number-precision';
import React, { useContext } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { VisualizarCategoriasCompra } from '../../VisualizarCategoriasCompra';
import VisualizarCompraAnexos from '../../VisualizarCompraAnexos';
import VisualizarCompraAproveitamentoCredito from '../../VisualizarCompraAproveitamentoCredito/VisualizarCompraAproveitamentoCredito';
import VisualizarCompraInformacoesPagamento from '../../VisualizarCompraInformacoesPagamento';
import VisualizarCompraServico from '../../VisualizarCompraServico';
import VisualizarDadosCompra from '../../VisualizarDadosCompra';
import VisualizarProdutos from '../../VisualizarProdutos';
import { compraModais } from '../compraModais';

const useStyles = makeStyles({
  dialogPaper: {
    maxWidth: 700,
  },
});

const VisualizarProdutoModal = ({ onVisualizarPedido }) => {
  const [modal, setModal] = useContext(CompraContext).modal;
  const [compra] = useContext(CompraContext).compraAtual;

  const styles = useStyles();

  const tipos = {
    produto: 'PRODUTO',
    servico: 'SERVICO',
  };

  const titulos = {
    PRODUTO: 'Compra de produto',
    SERVICO: 'Compra de serviço',
  };

  const tipo = compra?.comprasProdutos?.length ? tipos.produto : tipos.servico;

  // FA-08 Fechar
  const handleCloseModal = () => {
    setModal(false);
  };

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const handleOpenEditMode = async () => {
    const response = await fechamentoPeriodoApi.buscarUltimoPeriodo('COMPRAS_PAGAMENTO', compra.dataCompra);
    if (response.data && response.data.bloquearAnteriores) {
      if (
        moment(compra.dataCompra).isSameOrBefore(response.data.periodo) &&
        response.data.funcionalidades.includes('COMPRAS_PAGAMENTO')
      ) {
        if (compra.compraServico) {
          throw apiUtils.handleApiError({
            message:
              'Não é possível lançar, editar e excluir compras com datas referentes a um período já fechado no sistema.',
          });
        } else {
          throw apiUtils.handleApiError({
            message:
              'A compra de produto não pode ser editada porque a data da compra refere-se a um período já fechado no sistema e não pode haver movimentações',
          });
        }
      }
    }
    setModal(tipo === tipos.servico ? compraModais.comprarServico : compraModais.comprarProduto);
  };

  const Content = () => {
    const valorTotalCategorias = compra?.categorias?.reduce((acc, categoria) => {
      const valorItem = Number(categoria?.valorBruto) || 0;
      return NP.plus(acc, valorItem);
    }, 0);

    return (
      <>
        <VisualizarDadosCompra values={compra} />
        <VisualizarCategoriasCompra values={compra} />
        {tipo === tipos.produto && (
          <>
            <VisualizarProdutos values={compra} />
            <FormTitle title="Informações da Nota Fiscal" />
            <Grid container spacing={3} className="mb-8">
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextLabel label="Documento fiscal" id="documentoFiscal" value={compra.documentoFiscal} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <DateLabel label="Data da emissão" id="dataEmissao" value={compra.dataEmissao} />
              </Grid>
            </Grid>
          </>
        )}
        {tipo === tipos.servico && <VisualizarCompraServico values={compra} />}
        <VisualizarCompraInformacoesPagamento values={compra} />
        <VisualizarCompraAproveitamentoCredito
          values={compra?.aproveitamentoCredito}
          valorTotalCategorias={valorTotalCategorias}
        />
        {compra?.anexos?.length && <VisualizarCompraAnexos values={compra.anexos} />}
      </>
    );
  };

  const actions = [];

  if (permissaoUtils.compra().editar) {
    actions.push({
      label: 'Editar',
      onClick: handleOpenEditMode,
    });
  }

  if (permissaoUtils.compra().visualizar) {
    actions.push({
      label: 'Emitir pedido de compras',
      onClick: () => onVisualizarPedido(compra),
    });
  }

  return (
    <SimpleDialog
      open={modal === compraModais.visualizarCompra}
      onClose={handleCloseModal}
      paperClass={styles.dialogPaper}
    >
      <SimpleDialogContent
        header={{
          title: titulos[tipo],
          icon: <FaShoppingCart />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
              <GroupButton label="Ações" actions={actions} />
            </>
          ),
        }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarProdutoModal;
